

const getFormattedDateTime = () => {
    const now = new Date();

    const timeOptions = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const dateOptions = {
      weekday: "short",
      month: "short",
      day: "numeric",
    };

    // Format time and date separately
    const formattedTime = now.toLocaleTimeString("en-US", timeOptions);
    const formattedDate = now.toLocaleDateString("en-US", dateOptions);

    // Return as an object
    return {
      time: formattedTime,
      date: formattedDate,
    };
  };

  const formattedDateTime = (dateString) => {
    // Convert the date string to a Date object
    const date = new Date(dateString);
  
    const dateOptions = {
      weekday: "short",
      month: "short",
      day: "numeric",
    };
  
    // Format the date using toLocaleDateString
    const formattedDate = date.toLocaleDateString("en-US", dateOptions);
  
    // Return the formatted date
    return {
      date: formattedDate,
    };
  };

  const  extractTimeWithAMPM = (dateTimeStr)=> {
    // Split the date-time string and extract the time
    const time = dateTimeStr.split('T')[1].substring(0, 5); // Get 'HH:MM'
    const [hours, minutes] = time.split(':');
    
    // Convert to integer to handle AM/PM format
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? 'PM' : 'AM'; // Determine AM or PM

    // Convert hour to 12-hour format
    const hourIn12Format = hour % 12 || 12; // Converts 0 to 12 for 12 AM

    // Format the final time string
    return `${hourIn12Format}:${minutes} ${period}`;
}
  

const  formatDate = (isoDate)=> {
  const date = new Date(isoDate);

  const options = { day: "numeric", month: "long", year: "numeric" };
  return date.toLocaleDateString("en-GB", options);
}


const addTimeToTimeString = (timeString, hoursToAdd, minutesToAdd) => {
  // Validate the input time string
  if (!timeString || typeof timeString !== 'string') {
    console.error("Invalid timeString:", timeString);
    return "Invalid time"; // Return a fallback value
  }

  // Parse the input time string (HH:MM AM/PM)
  let timeParts = timeString.match(/(\d+):(\d+) (\w{2})/); // Matches '12:24 PM'
  if (!timeParts) {
    console.error("Time string doesn't match expected format:", timeString);
    return "Invalid format"; // Return a fallback value
  }

  let hours = parseInt(timeParts[1], 10);
  let minutes = parseInt(timeParts[2], 10);
  let period = timeParts[3]; // 'AM' or 'PM'

  // Convert the time to 24-hour format
  if (period === "PM" && hours !== 12) hours += 12; // Convert PM times
  if (period === "AM" && hours === 12) hours = 0; // Convert 12 AM to 0 hours

  // Add hours and minutes
  hours += hoursToAdd;
  minutes += minutesToAdd;

  // Adjust minutes and hours if minutes exceed 60
  if (minutes >= 60) {
    hours += Math.floor(minutes / 60);
    minutes = minutes % 60;
  }

  // Adjust hours if it exceeds 24
  if (hours >= 24) {
    hours = hours % 24;
  }

  // Convert back to 12-hour format and decide AM/PM
  let newPeriod = hours >= 12 ? "PM" : "AM";
  if (hours > 12) hours -= 12;
  if (hours === 0) hours = 12; // 12 AM or 12 PM

  // Format the new time
  return `${hours}:${minutes < 10 ? "0" + minutes : minutes} ${newPeriod}`;
};

const getBackgroundClass = (timeOfDay) => {
  if (timeOfDay === "morning") return "bg-morning";
  if (timeOfDay === "evening") return "bg-evening";
  if (timeOfDay === "night") return "bg-night";
  return "bg-morning"; // Default to morning
};

 

  export { getFormattedDateTime, formattedDateTime, extractTimeWithAMPM, formatDate, addTimeToTimeString, getBackgroundClass}